import React, { Component } from 'react';
import { makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import Cookies from 'js-cookie';
import qs from 'qs';

import { chatStore, rSocket } from '../../../../store/FrontChatStore';
import companyStore from '../../../../store/CompanyStore';
import { navigate } from '../../../../helper/HistoryHelper';
import {
  COOKIE_KEY_CHANNEL_ID,
  COOKIE_KEY_USER_KEY,
} from '../../../../const/AppConst';

import Styles from './DaishinCloseView.module.scss';

const DAISHIN_COMPANY_ID = '17';

@observer
class DaishinCloseView extends Component {
  constructor(props) {
    super(props);
    makeObservable(this);
    let queryParam = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    let isRating = queryParam.isRating;
    rSocket.requestChatApi(`/app/setting`).then(({ data }) => {
      this.message =
        isRating === 'true'
          ? data?.chatRatingClosedMessage
          : data?.chatClosedMessage;
    });
  }

  componentDidMount() {
    companyStore.fetchCompany(DAISHIN_COMPANY_ID);
  }

  @observable
  message = '챗봇 상담을 종료했습니다.';

  render() {
    const company = companyStore.company;
    const symbolUrl = company?.symbolLogo?.fullUrl ?? null;
    const characterUrl =
      company?.logoFile?.fullUrl ?? company?.symbolLogo?.fullUrl ?? null;
    const companyName = company?.companyName ?? '대신증권';

    return (
      <div className={Styles.Container}>
        <div className={Styles.HeaderContainer}>
          <div className={Styles.HeaderGradientBar} />
          <div className={Styles.Header}>
            {symbolUrl && (
              <img
                src={symbolUrl}
                alt={companyName}
                className={Styles.LogoMini}
              />
            )}
            <span className={Styles.BrandName}>{companyName} 상담봇</span>
          </div>
        </div>
        <div className={Styles.CloseContent}>
          <div className={Styles.CloseBody}>
            <div className={Styles.Character}>
              {characterUrl && (
                <img
                  src={characterUrl}
                  alt={companyName}
                  style={{
                    width: '200px',
                    height: '200px',
                    objectFit: 'contain',
                    backgroundColor: 'transparent',
                  }}
                />
              )}
            </div>
            <div className={Styles.LabelWrap}>
              <div className={Styles.Title}>{this.message}</div>
              <ul className={Styles.Label}>
                <li>
                  <p>
                    일정시간 입력이 없는 경우, 개인 정보 보호를 위해 챗봇과
                    상담을 종료합니다.
                  </p>
                </li>
                <li>
                  <p>채팅 상담을 원하시면, 상담 재시작 버튼을 선택해 주세요.</p>
                </li>
              </ul>
            </div>
          </div>
          <button
            className={Styles.RestartButton}
            onClick={() => {
              chatStore.setChannel(undefined);
              navigate(
                `/?user_id=${Cookies.get(COOKIE_KEY_USER_KEY)}&chnlId=${Cookies.get(COOKIE_KEY_CHANNEL_ID)}`,
              );
            }}
          >
            상담 재시작
          </button>
        </div>
      </div>
    );
  }
}

export default DaishinCloseView;
